import React from "react"

import { ChatTranscripts } from "views/Chat/ChatTranscripts"
import { ContactDetails } from "widgets/ContactDetails"
import useHasFeature, { AppFeatures } from "hooks/useHasFeature"
import { IInteraction } from "../../types"
import { ISocialChatMessage } from "store/chat/chat.state"

import "./chat-view.scss"

export interface Props {
    interaction: IInteraction
}

const ChatView: React.FC<Props> = ({ interaction }) => {
    const hasFeature = useHasFeature()

    const { ID: InteractionID, attributesUpdated = false, channelType, transcript } = interaction;
    
    const isSMSCampaignETR = ["SMS CAMPAIGN-MESSAGE", "SMS MARKETING-MESSAGE"].includes(channelType);

    // Render a column out if the user has permissions for any of its features
    const renderLeftColumn = hasFeature(AppFeatures.CHAT_DETAILS)
    const renderRightColumn = hasFeature(AppFeatures.SOCIAL_CHAT_MESSAGES) || isSMSCampaignETR

    return (
        <div className="chat-view-container">
            {renderLeftColumn && (
                <div className="chat-view-container-left">
                    {hasFeature(AppFeatures.CHAT_DETAILS) && (
                        <ContactDetails contact={attributesUpdated ? interaction : undefined} />
                    )}
                </div>
            )}
            {renderRightColumn && (
                <div className="chat-view-container-right">
                    {isSMSCampaignETR ? (
                        transcript?.length ? (
                            <ChatTranscripts
                                socialChatTranscript={transcript as ISocialChatMessage[]}
                            />
                        ) : null
                    ) : (
                        hasFeature(AppFeatures.SOCIAL_CHAT_MESSAGES) && (
                            <ChatTranscripts contactID={InteractionID} />
                        )
                    )}
                </div>
            )}
        </div>
    )
}

export default ChatView
